import React from 'react';
import { Button, ButtonDropdown, DropdownItem, Icon, WeezHeader } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import UploadZone from './components/uploadZone';
import useModerationContext from '../../../../context/useModerationContext';

export default function FilesManagement({ organization, flowId, children }) {
    const { t } = useTranslation();

    const [{ download_all_enable, syncActiveTab }] = useModerationContext();

    const download_all = React.useCallback(() => {
        const url = `${window.weezConfig.api.apiUrl}/ticket/organizations/${organization.id}/moderation_flows/${flowId}/files/download_ready`;
        fetch(url)
            .then(response => {
                return response.arrayBuffer();
            })
            .then(data => {
                const blob = new Blob([data], { type: 'application/zip' });
                const file = window.URL.createObjectURL(blob);
                window.open(file, '_blank');
                syncActiveTab();
            });
    }, [organization, flowId, syncActiveTab, fetch]);

    return (
        <>
            <WeezHeader
                title={t('ticket.moderation.filesManagement.title')}
                rightComponent={[
                    <ButtonDropdown
                        key={0}
                        renderWhenClosed
                        trigger={<Button inverted primary icon={<Icon name="chevron-bottom" />} label={t('ticket.common.cta.actions')} />}
                        items={
                            <>
                                <DropdownItem item={t('ticket.moderation.filesManagement.downloadAll')} onClick={download_all} disabled={!download_all_enable} />
                            </>
                        }
                    />
                ]}
            >
                {t('ticket.moderation.filesManagement.subtitle')}
            </WeezHeader>
            <UploadZone organizationId={organization.id} flowId={flowId} />
            {React.cloneElement(children, { organization, flowId })}
        </>
    );
}
